/* eslint-disable max-lines */
/* eslint-disable complexity */
import {
  Component,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  BookWidgetAem,
  BookWidgetFieldUpdateEvent,
  SearchModalEvent,
  SearchModalEventType
} from '@com-delta-idp/mnx-capability-flight-shop-ui';
import {
  AnalyticsDataPopulateService,
  PopulateAnalytics
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { UiStateManagementService } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  getQueryParameter,
  stringToBoolean
} from '../data-access/adapters/utils/utils.adapter';
import {
  edocsLocalStorageKey,
  RetrieveSearchMcCookieName
} from '../data-access/constants/common.constants';
import { FlightShopWidgetTemplates } from '../data-access/constants/flight-shop.constants';
import { AemFacade } from '../data-access/facades/aem.facade';
import { BookWidgetFacade } from '../data-access/facades/book-widget.facade';
import { CatalogApiFacade } from '../data-access/facades/catalog-api.facade';
import { DefaultLookupFacade } from '../data-access/facades/default-lookup.facade';
import { FeatureFlagsFacade } from '../data-access/facades/feature-flags.facade';
import { GeoLocationFacade } from '../data-access/facades/geo-location.facade';
import { LoginDashboardFacade } from '../data-access/facades/login-dashboard.facade';
import { QueryParamsFacade } from '../data-access/facades/query-params.facade';
import { RetrieveSearchFacade } from '../data-access/facades/retrieve-search.facade';
import { SearchModalFacade } from '../data-access/facades/search-modal.facade';
import { DefaultLookupResponse } from '../data-access/models/core-apis/default-lookup.interfaces';
import {
  RetrieveSearchMcResponse,
  RetrieveSearchOwRtResponse
} from '../data-access/models/core-apis/retrieve-search.interfaces';
import { QueryParams } from '../data-access/models/states/query-params-state.interfaces';
import { DateUtilitiesService } from '../data-access/services/date-utilities.service';
import { UtilsService } from '../data-access/services/utils.service';

@Component({
  selector: 'idp-capability-flight-shop',
  templateUrl: './flight-shop.component.html',
  styleUrls: ['./flight-shop.component.scss']
})
export class FlightShopComponent implements OnInit {
  @Input() flightShopWidgetTemplates: FlightShopWidgetTemplates =
    FlightShopWidgetTemplates.APP;

  @Input() queryParams: QueryParams | null = null;

  @Input() defaultLookupResponse: DefaultLookupResponse | null = null;

  @Input() bookWidgetAem: BookWidgetAem | null = null;

  /**
   * Either pass retrieveSearchOwRtResponse / retrieveSearchMcResponse OR let booking widget call retrieve search on it's own
   */
  @Input() retrieveSearchOwRtResponse: RetrieveSearchOwRtResponse[] | null =
    null;

  @Input() retrieveSearchMcResponse: RetrieveSearchMcResponse | null = null;

  @Input() viewSearchOptionExpanded = false;

  @Output() expandEmit = new EventEmitter();

  isBookWidgetReady$ = this.bookWidgetFacade.isBookWidgetReady$;

  bookWidgetFields$ = this.bookWidgetFacade.bookWidgetFields$;

  guidedNavigationErrorMsg$ = this.bookWidgetFacade.guidedNavigationErrorMsg$;

  bookWidgetAem$ = this.aemFacade.bookWidgetAem$;

  searchModalTabs$ = this.searchModalFacade.searchModalTabs$;

  searchModalRecentSearchList$ =
    this.searchModalFacade.searchModalRecentSearchList$;

  searchModalSavedSearchList$ =
    this.searchModalFacade.searchModalSavedSearchList$;

  searchModalPredictiveSearchList$ =
    this.searchModalFacade.searchModalPredictiveSearchList$;

  FlightShopWidgetTemplates = FlightShopWidgetTemplates;

  datepickerConfig = this.dateUtilitiesService.getDatepickerConfig();

  isDesktop = window.innerWidth >= 992;
  analyticsService = inject(AnalyticsDataPopulateService);
  constructor(
    private aemFacade: AemFacade,
    private geoLocationFacade: GeoLocationFacade,
    private catalogApiFacade: CatalogApiFacade,
    private defaultLookupFacade: DefaultLookupFacade,
    private retrieveSearchFacade: RetrieveSearchFacade,
    private featureFlagsFacade: FeatureFlagsFacade,
    private utilsService: UtilsService,
    private queryParamsFacade: QueryParamsFacade,
    private bookWidgetFacade: BookWidgetFacade,
    private loginDashboardFacade: LoginDashboardFacade,
    private searchModalFacade: SearchModalFacade,
    private dateUtilitiesService: DateUtilitiesService,
    private uiStateManagementService: UiStateManagementService
  ) {}

  @HostListener('window:resize')
  isDesktopFn() {
    this.isDesktop = window.innerWidth >= 992;
  }

  ngOnInit(): void {
    const accountCookie = this.utilsService.getAccountCookieValue();
    const isHipmunk = this.utilsService.getCookies('isHipmunk') ? true : false;

    const skipGeoLocationApi =
      this.flightShopWidgetTemplates === FlightShopWidgetTemplates.MODIFY;

    const cacheKeySuffixFromUrl = getQueryParameter('cacheKeySuffix');
    const cacheKeySuffix =
      cacheKeySuffixFromUrl &&
      localStorage.getItem(`postData${cacheKeySuffixFromUrl}`)
        ? cacheKeySuffixFromUrl
        : '';

    const triggerDefaultsLookupLanding =
      !this.defaultLookupResponse &&
      stringToBoolean(
        localStorage.getItem(`${edocsLocalStorageKey}${cacheKeySuffix}`)
      );

    const triggerRetrieveSearchLanding =
      !this.retrieveSearchOwRtResponse && !this.retrieveSearchMcResponse;

    //Store config values - Start
    this.bookWidgetFacade.setFlightShopTemplateType(
      this.flightShopWidgetTemplates
    );
    this.queryParamsFacade.storeInputValues(this.queryParams);
    this.featureFlagsFacade.storeFeatureFlagsValues();
    this.loginDashboardFacade.storeInputValues(accountCookie, isHipmunk);
    this.geoLocationFacade.storeInputValues(skipGeoLocationApi);
    this.retrieveSearchFacade.storeInputValues(
      triggerRetrieveSearchLanding,
      this.utilsService.getCookies(RetrieveSearchMcCookieName) || '',
      this.retrieveSearchOwRtResponse,
      this.retrieveSearchMcResponse
    );
    this.defaultLookupFacade.storeInputValues(
      cacheKeySuffix,
      triggerDefaultsLookupLanding,
      this.defaultLookupResponse
    );
    //Store config values - End

    //API Triggers

    this.bookWidgetFacade.triggerInitFields(); //This action is used when data of all below API triggers values are coming from store itself, so none of their api success actions are fired. In that case we still want the defaultValueEvaluation$ action in book-widget-fields-init.effects.ts to fire

    if (this.bookWidgetAem && Object.keys(this.bookWidgetAem).length) {
      this.aemFacade.storeBookWidgetAem(this.bookWidgetAem);
    } else {
      this.aemFacade.loadBookWidgetAem();
    }

    this.catalogApiFacade.loadCatalogApiData();
    this.loginDashboardFacade.loadDashboardLanding();

    if (triggerDefaultsLookupLanding) {
      this.defaultLookupFacade.loadDefaultLookupLanding();
    }

    if (triggerRetrieveSearchLanding) {
      this.retrieveSearchFacade.loadRetrieveSearch();
    }

    if (!skipGeoLocationApi) {
      this.geoLocationFacade.loadGeoLocation();
    }
  }

  handleSearchModalEvent(event: SearchModalEvent<SearchModalEventType>) {
    this.searchModalFacade.handleSearchModalEvent(event);
  }

  bookWidgetFieldChangeHandler(
    bookWidgetFieldUpdateEvent: BookWidgetFieldUpdateEvent
  ) {
    this.bookWidgetFacade.bookWidgetFieldChangeHandler(
      bookWidgetFieldUpdateEvent
    );
  }

  swapAirportsHandler(flightIndex: number) {
    this.bookWidgetFacade.swapAirportsHandler(flightIndex);
  }

  addFlightsForMcHandler() {
    this.bookWidgetFacade.addFlightsForMcHandler();
  }

  removeFlightForMcHandler() {
    this.bookWidgetFacade.removeFlightForMcHandler();
  }

  findFlightClicked() {
    this.bookWidgetFacade.findFlightInitiated();
  }

  onViewSearchOptionsHandler() {
    this.uiStateManagementService.toggleExpandView();
    this.expandEmit.emit();
  }

  handleAnalytics(element: PopulateAnalytics): void {
    this.analyticsService.populateAnalyticsData(
      element.el,
      element.event,
      element.search,
      element.useAttrs,
      element.filters
    );
  }
}
